export default __webpack_public_path__ + "static/media/MoveImproveNew.729b4073.webp";